import { useAuthStep } from './useAuthStep'
import { AuthStepUI } from './AuthStepUI'

export const AuthStep = () => {
  const props = useAuthStep()
  return <AuthStepUI {...props} />
}
